<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]">
    <!-- <the-customizer v-if="!disableCustomizer" :footerType="footerType" :hideScrollToTop="hideScrollToTop"
      :navbarType="navbarType" :navbarColor="navbarColor" :routerTransition="routerTransition"
      @toggleHideScrollToTop="toggleHideScrollToTop" @updateFooter="updateFooter" @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor" @updateRouterTransition="updateRouterTransition" /> -->

    <v-nav-menu :navMenuItems="navMenuItems" title="Vuexy" parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />
      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1250">
        <the-navbar-horizontal :navbarType="navbarType" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" :navMenuItems="navMenuItems" />
      </template>

      <template v-else>
        <div class="xl:hidden">
          <the-navbar-vertical :navbarColor="navbarColor" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />
        </div>
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div v-if="breadcrumb.length || $route.meta.pageTitle" class="router-header flex flex-wrap justify-between mb-6">
                <div class="flex flex-wrap items-center mb-6">
                  <div class="content-area__heading" :class="{ 'pr-4 border-0 md:border-r border-solid border-grey-light': breadcrumb.length }">
                    <h2 class="mb-1">{{ routeTitle }}</h2>
                  </div>

                  <!-- BREADCRUMB -->
                  <vx-breadcrumb class="ml-4 md:block hidden" v-if="breadcrumb.length" :breadcrumb="breadcrumb" :isRTL="$vs.rtl" />
                </div>
                <div class="hidden xl:flex items-center mb-6">
                  <admin-header-actions />
                </div>
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" @update-breadcrumb="updateBreadcrumb" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import BackToTop from 'vue-backtotop'
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheCustomizer from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import AdminHeaderActions from '@/layouts/components/navbar/components/AdminHeaderActions.vue'

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheCustomizer,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    AdminHeaderActions
  },
  data() {
    return {
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems,
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: '',
      breadcrumb: []
    }
  },
  computed: {
    ...mapState('auth', ['userRole']),
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark() {
      return this.$store.state.theme === 'dark'
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    redirectToDestination() {
      const hostname = window.location.hostname
      const currentPath = this.$route.path

      // If user is already on a specific portal route, don't redirect them away
      if (currentPath !== '/' && currentPath !== '/home' && currentPath !== '/dashboard') {
        return
      }

      // Handle Redirection based on Subdomain and available roles
      if (hostname.includes('mygurudwara') || hostname.includes('gurudwara')) {
        if (this.userRole === 'Gurudwara Admin' || this.userRole === 'Committee Admin') {
          this.$router.push('/gurudwara/list')
        }
      } else if (hostname.includes('myorganization') || hostname.includes('organization')) {
        if (this.userRole === 'Organization Admin') {
          this.$router.push('/organization/list')
        }
      } else if (hostname.includes('myhotel') || hostname.includes('hotel')) {
        if (this.userRole === 'Hotel Manager') {
          this.$router.push('/hotel-dashboard')
        }
      } else {
        // Fallback for main domain or if no subdomain match
        if (this.userRole === 'Gurudwara Admin') {
          this.$router.push('/gurudwara/list')
        } else if (this.userRole === 'Organization Admin') {
          this.$router.push('/organization/list')
        }
      }
    },
    setBreadcrumb() {
      // Default to empty breadcrumb
      this.breadcrumb = []
      const { meta, matched } = this.$route
      // Set breadcrumb from route meta if available
      if (meta && meta.breadcrumb) {
        this.breadcrumb = meta.breadcrumb
        return
      }

      // Iterate through matched routes to find breadcrumb
      for (let i = matched.length - 1; i >= 0; i--) {
        const component = matched[i].components.default

        if (component && typeof component.data === 'function') {
          const data = component.data()

          if (data && data.breadcrumb) {
            this.breadcrumb = data.breadcrumb
            return
          }
        }
      }
    },
    updateBreadcrumb(newBreadcrumb) {
      this.breadcrumb = newBreadcrumb
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1250) || (layoutType === 'vertical' && this.windowWidth < 1250)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  },
  async mounted() {
    this.redirectToDestination()
  },
  watch: {
    $route(newRoute) {
      // Handle route change if $route or meta is undefined
      if (newRoute && newRoute.meta && newRoute.meta.pageTitle) {
        this.routeTitle = newRoute.meta.pageTitle
      } else {
        this.routeTitle = '' // Or handle missing title in another way
      }
      this.setBreadcrumb()
    },
    isThemeDark(val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType'(val) {
      this.setNavMenuVisibility(val)
    }
  },
  created() {
    // Check if this.$route and its meta exist
    if (this.$route && this.$route.meta && this.$route.meta.pageTitle) {
      this.routeTitle = this.$route.meta.pageTitle
    }
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#fff' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    this.setBreadcrumb() // Initialize breadcrumb on creation
  }
}
</script>
<style>
/* Add to your style section or global CSS */
.theme-toggle-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s;
}

.theme-toggle-circle:hover {
  background: #444;
}
</style>
